function base64ToBytes(base64: string) {
  const binString = window.atob(base64);
  return Uint8Array.from(binString, m => m.codePointAt(0)!);
}

function bytesToBase64(bytes: Uint8Array) {
  const binString = Array.from(bytes, byte => String.fromCodePoint(byte)).join("");
  return window.btoa(binString);
}

const HEncodeObj = (obj: any) => {
  return bytesToBase64(new TextEncoder().encode(JSON.stringify(obj)));
};

const HDecodeObj = (resp: string) => {
  return JSON.parse(new TextDecoder().decode(base64ToBytes(resp)));
};

export { HEncodeObj, HDecodeObj };
